import { Router } from "vue-router";
import { Storage } from "@/utils/Storage";
import store from "@/store";

// 需要管理权限才能进入的页面
const authorizedRouteList = ["/write"];

/**
 * 创建全局路由守卫
 * @param router 路由
 */
export function createRouterGuards(router: Router) {
  router.beforeEach((to, from, next) => {
    /* 当前路由 */
    store.commit("common/setCurrentRout", to.fullPath);
    /* 保证vuex中的isOwner不被页面刷新而丢失 */
    const isOwnerLocal = Storage.get("IS_OWNER");
    const isOwner = store.state.common.isOwner;
    if (!isOwner && isOwnerLocal) {
      store.commit("common/setIsOwner", isOwnerLocal);
    }
    /* 拒绝某些非法的路由（非登录状态下的管理、编辑页面），可以通过动态路由实现 */
    if (isOwnerLocal) {
      next();
    } else {
      if (authorizedRouteList.contains((path) => path == to.fullPath)) {
        next({ path: from.fullPath });
      } else {
        next();
      }
    }
  });
  router.afterEach((to, from, failure) => {
    document.title = (to?.meta?.title as string) || document.title;
  });
  router.onError((error) => {
    console.log(error, "路由错误");
  });
}
